export default __webpack_public_path__ + "static/media/as.db9b5d02.svg";